/* global process, URL */
const S3_META_HOST = "shop-meta.s3.ap-south-1.amazonaws.com";
// New media bucket (dayzero account). Old-field URLs from new uploads point here (img/<id>/v1/512.webp).
const MEDIA_BUCKET_HOST = (
  process.env.NEXT_PUBLIC_MEDIA_BUCKET_HOST || "sh0p-media.s3.ap-south-1.amazonaws.com"
)
  .replace(/^https?:\/\//, "")
  .replace(/\/$/, "");

const isCdnEnabled = () => process.env.NEXT_PUBLIC_CDN_ENABLED === "true";

export const getCdnHost = () =>
  (process.env.NEXT_PUBLIC_CDN_HOST || "").replace(/^https?:\/\//, "").replace(/\/$/, "");

export const isS3MetaUrl = (url) => {
  if (!url) return false;

  try {
    const { hostname } = new URL(url);
    return hostname === S3_META_HOST || hostname.includes("shop-meta.s3");
  } catch {
    return typeof url === "string" && url.includes("shop-meta.s3");
  }
};

/** URLs on the new media bucket are also served by the same CloudFront distribution (/img/*, /raw/*). */
export const isMediaBucketUrl = (url) => {
  if (!url) return false;
  try {
    return new URL(url).hostname === MEDIA_BUCKET_HOST;
  } catch {
    return typeof url === "string" && url.includes(MEDIA_BUCKET_HOST);
  }
};

/** Rewrite shop-meta / media-bucket S3 URLs to CloudFront when the flag is on. Azure and other hosts are unchanged. */
export const toCdnUrl = (url) => {
  if (!url || !isCdnEnabled()) return url;

  const cdnHost = getCdnHost();
  if (!cdnHost || !(isS3MetaUrl(url) || isMediaBucketUrl(url))) return url;

  try {
    const parsed = new URL(url);
    parsed.protocol = "https:";
    parsed.host = cdnHost;
    return parsed.toString();
  } catch {
    return url;
  }
};
